export const BOOKING_REFUND_CREDIT_TYPE = 'Booking Refund';
export const CREDIT_TYPE_GIFTCARD = 'Giftcard';
export const CREDIT_TYPE_STRIPE_INVOICE = 'Stripe Invoice';
export const CREDIT_TYPE_STORE_CREDIT = 'Store credit';
export const CREATE_TYPE_TRANSFERRING_CREDIT = 'Transferring Credit';
export const CREATE_TYPE_REACTIVATED_CREDIT = 'Reactivated Credit';
export const CREATE_TYPE_PEOPLE_AND_CULTURE = 'People & Culture';
export const CREATE_TYPE_OTHER = 'Other';
export const CREDIT_TYPE_CRUISE_OFFER_PACKAGE_CREDIT = 'Offer package credits';
export const CREDIT_TYPE_LEBT_ISSUED = 'LEBT issued';
export const STRIPE_PAYMENT_ZONES = [
  'LE (AU)',
  'LE (NZ)',
  'LE (Singapore)',
  'LE US - New York',
  'LE Flights',
  'LE Int Flights',
  'LE US - Flights',
];

export const CREDIT_TYPE_BULK_CORPORATE_GIFT_CARD_PURCHASE = 'Bulk Corporate Gift Card Purchase';
export const CREDIT_TYPE_AGENT_HUB = 'Agent Hub';
export const CREDIT_TYPE_TEST_CREDIT = 'Test Credit';

export const CREDIT_TYPES_WITHOUT_TICKET_ID = [
  CREDIT_TYPE_BULK_CORPORATE_GIFT_CARD_PURCHASE,
  CREDIT_TYPE_AGENT_HUB,
  CREDIT_TYPE_TEST_CREDIT,
];

export const CREDIT_EXTENSION_TYPES = [
  { creditExtensionType: 'Reducing Credit Expiry' },
  { creditExtensionType: 'Aligning Credit with previous expiry (Credit Transfer)' },
  { creditExtensionType: 'Stripe Invoice - Adjusting the expiry date to 12 months' },
  { creditExtensionType: 'Goodwill extension of 1 month' },
  { creditExtensionType: 'Offline/Manual Cancellation' },
  { creditExtensionType: 'Other' },
];

export const TWELVE_MONTH_EXPIRY = 12;
export const ONE_MONTH_EXPIRY = 1;

export const CREDIT_TYPES = [
  { creditType: 'Giftcard' },
  { creditType: 'Stripe Invoice' },
  { creditType: 'Refund of Fraudulent Spend' },
  { creditType: 'Cancellation of Fraudulent Credit' },
  { creditType: 'Marketing' },
  { creditType: 'Transferring Credit' },
  { creditType: 'Manual Bank Transfer', label: 'Manual Bank Transfer to LE' },
  { creditType: 'Reactivated Credit' },
  { creditType: CREDIT_TYPE_BULK_CORPORATE_GIFT_CARD_PURCHASE },
  { creditType: CREDIT_TYPE_STORE_CREDIT },
  { creditType: 'People & Culture' },
  { creditType: CREDIT_TYPE_LEBT_ISSUED },
  { creditType: CREDIT_TYPE_CRUISE_OFFER_PACKAGE_CREDIT },
  { creditType: 'PayTo credit' },
  // New credit types
  { creditType: 'Bonus Credit' },
  { creditType: BOOKING_REFUND_CREDIT_TYPE },
  { creditType: 'Credit Forfeit' },
  { creditType: 'Goodwill Gesture' },
  { creditType: 'Manual Refund to Cash' },
  { creditType: 'Merchant fee/ Credit Card Fee' },
  { creditType: 'Purchase/ Deposit (spent)' },
  { creditType: 'Temporary Removal/ Addition' },
  { creditType: 'Chargeback' },
  { creditType: 'Credit Reversal to Cash' },
  { creditType: CREDIT_TYPE_AGENT_HUB, label: 'Agent Hub, Commercial team only' },
  // Test Credit type is available to all accounts
  { creditType: CREDIT_TYPE_TEST_CREDIT },
];
